// The App message catalogue, assembled from one file per delivery track.
//
// WHY SPLIT — the same reason Book's is: this is the file every screen must
// touch, so a single flat catalogue conflicts on every merge when several
// screens are in flight. Each track gets an exclusive file and this merger is
// the only shared surface.
//
// The rationale for a hand-rolled catalogue over an i18n library lives in
// shared/i18n/engine.ts, and the rule that Spanish is never invented here lives
// in ./core.ts. Both apply to every file merged below.

import { en as coreEn, es as coreEs } from "./core";
import { en as authEn, es as authEs } from "./auth";
import { en as authActionEn, es as authActionEs } from "./authAction";
import { en as paymentsEn, es as paymentsEs } from "./payments";
import { en as partnerEn, es as partnerEs } from "./partner";

export const en = {
  ...coreEn,
  ...authEn,
  ...authActionEn,
  ...paymentsEn,
  ...partnerEn,
} as const;

export type MessageKey = keyof typeof en;

// Spread in the same order as `en` so a key defined in two catalogues resolves
// consistently in both languages rather than diverging by locale.
export const es: Partial<Record<MessageKey, string>> = {
  ...coreEs,
  ...authEs,
  ...authActionEs,
  ...paymentsEs,
  ...partnerEs,
};

export const catalogues = { en, es } as const;
export type Locale = keyof typeof catalogues;
export const LOCALES: readonly Locale[] = ["en", "es"];
